const safeStringify = (value) => {
    try {
        return JSON.stringify(value)
    } catch (e) {
        return ''
    }
}

const cloneHexState = (hexState) => {
    try {
        return JSON.parse(JSON.stringify(hexState))
    } catch (e) {
        return hexState
    }
}

const normalizeHexStateForCompare = (hexState) => {
    const cloned = cloneHexState(hexState)
    if (cloned && cloned.logicTwo) {
        delete cloned.logicTwo.offset
        delete cloned.logicTwo.scale
    }

    if (cloned && cloned.logicTwoContent) {
        delete cloned.logicTwoContent.offset
        delete cloned.logicTwoContent.scale
    }
    return cloned
}

const buildHexStateHash = (hexState) => {
    return safeStringify(normalizeHexStateForCompare(hexState))
}

const buildStep = (index, hexState) => {
    return {
        id: index,
        title: '',
        instruction: '',
        hexState: cloneHexState(hexState),
    }
}

const buildInitialState = (hexState) => {
    if (!hexState) {
        return {
            current: null,
            previous: null,
            steps: [],
            activeStepIndex: 0,
            currentHash: '',
        }
    }

    return {
        current: cloneHexState(hexState),
        previous: null,
        steps: [buildStep(0, hexState)],
        activeStepIndex: 0,
        currentHash: buildHexStateHash(hexState),
    }
}

const initialState = buildInitialState(null)

const hexStateReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case 'HEX_STATE_INIT': {
            return buildInitialState(payload)
        }
        case 'HEX_STATE_SYNC': {
            if (!payload) {
                return state
            }

            const nextHash = buildHexStateHash(payload)
            if (nextHash && nextHash === state.currentHash) {
                return state
            }

            const nextIndex = state.steps.length
            const nextStep = buildStep(nextIndex, payload)

            return {
                ...state,
                previous: state.current,
                current: cloneHexState(payload),
                steps: [...state.steps, nextStep],
                activeStepIndex: nextIndex,
                currentHash: nextHash,
            }
        }
        case 'HEX_STEP_META_UPDATE': {
            if (!payload || typeof payload.stepIndex !== 'number') {
                return state
            }
            if (
                payload.stepIndex < 0 ||
                payload.stepIndex >= state.steps.length
            ) {
                return state
            }

            const { stepIndex, title, instruction } = payload

            const steps = state.steps.map((step, index) => {
                if (index !== stepIndex) {
                    return step
                }
                return {
                    ...step,
                    title: title !== undefined ? title : step.title,
                    instruction:
                        instruction !== undefined
                            ? instruction
                            : step.instruction,
                }
            })

            return {
                ...state,
                steps,
            }
        }
        case 'HEX_STATE_CLEAR': {
            const baseHexState = payload?.hexState || payload
            return buildInitialState(baseHexState || null)
        }
        case 'HEX_STEP_SET_ACTIVE': {
            if (!payload || typeof payload.stepIndex !== 'number') {
                return state
            }
            if (
                payload.stepIndex < 0 ||
                payload.stepIndex >= state.steps.length
            ) {
                return state
            }

            console.log('Setting active step to index', payload.stepIndex)

            return {
                ...state,
                activeStepIndex: payload.stepIndex,
            }
        }
        default:
            return state
    }
}

export default hexStateReducer
